import { delay1diib1rb84y4j as delay } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  intercepted2ogpsikxxj4u0 as intercepted,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CancellableContinuationImpl.mjs';
import {
  Companion_instance2oawqq9qiaris as Companion_instance,
  _Result___init__impl__xyqfz83hut4nr3dfvi3 as _Result___init__impl__xyqfz8,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { returnIfSuspendedqak8u4r448cu as returnIfSuspended } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coroutineInternalJS.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { generateSequence118suk3hffuuw as generateSequence } from '../../../../../kotlin-kotlin-stdlib/kotlin/sequences/Sequences.mjs';
import { mapsbvh18eqox7a as map } from '../../../../../kotlin-kotlin-stdlib/kotlin/sequences/_Sequences.mjs';
import {
  plus3pcnntex3h8m as plus,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  singleOrNullrknfaxokm1sl as singleOrNull,
  plus20p0vtfmu0596 as plus_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { BasicListenable3uz4a8xs34a0h as BasicListenable } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import {
  coroutineScope284yy3flyb2v2 as coroutineScope,
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  CoroutineScopelux7s7zphw7e as CoroutineScope_0,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import {
  boxApply1qmzdb3dh90hg as boxApply,
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  _ReactiveState___get_raw__impl__92ipya10f5f3x6hwqt0 as _ReactiveState___get_raw__impl__92ipya,
  InternalReactiveWrapper6qytbrc1rcqv as InternalReactiveWrapper,
  InternalReactiveThrownException1wn4fe03qbefg as InternalReactiveThrownException,
  InternalReactiveNotReady_instance37iasaqvolrrz as InternalReactiveNotReady_instance,
} from '../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  DataClassPathSelf9694s3fei65z as DataClassPathSelf,
  DataClassPathAccess21fi12r1lk4vq as DataClassPathAccess,
} from '../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import {
  get_serializableProperties2tbouuwr11am9 as get_serializableProperties,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { SortPart1gsioxz0aa07v as SortPart } from '../../../../../lightning-server-shared/com/lightningkite/lightningdb/SortPart.mjs';
import {
  Duration__toString_impl_8d916b11f1kpclwmkpg as Duration__toString_impl_8d916b,
  Duration__hashCode_impl_u4exz629donm5f9ouki as Duration__hashCode_impl_u4exz6,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import {
  Reactive1jy75v4li6ldv as Reactive,
  Listenable3m4zqvjcbvczy as Listenable,
  beginUse146s8dwmfk72s as beginUse,
} from '../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import {
  launch1c91vkjzdi9sd as launch,
  asyncz02dsa2nb2zt as async,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import {
  Key_instance2tirv2rj82ml4 as Key_instance,
  Job13y4jkazwjho0 as Job,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CompletableDeferred.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $completion) {
  var tmp = delay($this.veo_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var closer = {_v: InterruptibleDelay$delay$lambda$slambda$lambda};
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  var cancellable = new (CancellableContinuationImpl())(intercepted($completion), 1);
  cancellable.ra5();
  var cont = cancellable;
  closer._v = $this.weo_1.gem_1.tah(() => {
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = cont;
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
    this_0.rc(tmp$ret$0);
    return Unit_instance;
  });
  cont.ta7((it) => {
    closer._v();
    return Unit_instance;
  });
  var tmp$ret$3 = cancellable.sa5();
  var tmp = returnIfSuspended(tmp$ret$3, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  closer._v();
  return Unit_instance;
}
function InterruptibleDelay$delay$lambda$slambda$lambda() {
  return Unit_instance;
}
function *_generator_delay__nu7n9t($this, duration, $completion) {
  // Inline function 'kotlin.suspend' call
  var tmp$ret$0 = InterruptibleDelay$delay$slambda_0(duration);
  var tmp = listOf(tmp$ret$0);
  var tmp_0 = generateSequence($this, InterruptibleDelay$delay$lambda);
  var toRace = plus(tmp, map(tmp_0, InterruptibleDelay$delay$lambda_0));
  var tmp_1 = race(toRace, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return Unit_instance;
}
var InterruptibleDelay$delay$slambdaClass;
function InterruptibleDelay$delay$slambda() {
  if (InterruptibleDelay$delay$slambdaClass === VOID) {
    class $ {
      constructor($duration) {
        this.veo_1 = $duration;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    InterruptibleDelay$delay$slambdaClass = $;
  }
  return InterruptibleDelay$delay$slambdaClass;
}
function InterruptibleDelay$delay$slambda_0($duration) {
  var i = new (InterruptibleDelay$delay$slambda())($duration);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function InterruptibleDelay$delay$lambda(it) {
  return it.fem_1;
}
function InterruptibleDelay$delay$lambda_0(inter) {
  // Inline function 'kotlin.suspend' call
  return InterruptibleDelay$delay$lambda$slambda_0(inter);
}
var InterruptibleDelay$delay$lambda$slambdaClass;
function InterruptibleDelay$delay$lambda$slambda() {
  if (InterruptibleDelay$delay$lambda$slambdaClass === VOID) {
    class $ {
      constructor($inter) {
        this.weo_1 = $inter;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    InterruptibleDelay$delay$lambda$slambdaClass = $;
  }
  return InterruptibleDelay$delay$lambda$slambdaClass;
}
function InterruptibleDelay$delay$lambda$slambda_0($inter) {
  var i = new (InterruptibleDelay$delay$lambda$slambda())($inter);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var InterruptibleDelayClass;
function InterruptibleDelay() {
  if (InterruptibleDelayClass === VOID) {
    class $ {
      constructor(parent) {
        parent = parent === VOID ? null : parent;
        this.fem_1 = parent;
        this.gem_1 = BasicListenable().naq();
      }
      oen() {
        this.gem_1.oaq();
      }
      tat() {
        return new (InterruptibleDelay())(this);
      }
      hem(duration, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delay__nu7n9t.bind(VOID, this, duration), $completion);
      }
    }
    initMetadataForClass($, 'InterruptibleDelay', InterruptibleDelay, VOID, VOID, [1]);
    InterruptibleDelayClass = $;
  }
  return InterruptibleDelayClass;
}
function ResourceUse(parentScope, action) {
  parentScope = parentScope === VOID ? get_AppScope() : parentScope;
  return new (ResourceUse$1())(parentScope, action);
}
function uses(_this__u8e3s4, resource) {
  return new (uses$1())(_this__u8e3s4, resource);
}
function race(racers, $completion) {
  return coroutineScope(race$slambda_0(racers), $completion);
}
var BaseResourceUseClass;
function BaseResourceUse() {
  if (BaseResourceUseClass === VOID) {
    class $ {
      constructor($box) {
        boxApply(this, $box);
        this.teo_1 = 0;
      }
      ial() {
      }
      jal() {
      }
      iaj() {
        var _unary__edvuaz = this.teo_1;
        this.teo_1 = _unary__edvuaz + 1 | 0;
        if (_unary__edvuaz === 0) {
          this.ial();
        }
        var dead = {_v: false};
        return () => {
          var tmp;
          if (dead._v) {
            return Unit_instance;
          }
          dead._v = true;
          var tmp_0;
          this.teo_1 = this.teo_1 - 1 | 0;
          if (this.teo_1 === 0) {
            this.jal();
            tmp_0 = Unit_instance;
          }
          return Unit_instance;
        };
      }
    }
    initMetadataForClass($, 'BaseResourceUse');
    BaseResourceUseClass = $;
  }
  return BaseResourceUseClass;
}
function *_generator_waitFor__s3rt0g(_this__u8e3s4, matching, $completion) {
  // Inline function 'com.lightningkite.reactive.core.ReactiveState.onSuccess' call
  // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
  var this_0 = _this__u8e3s4.qah();
  var tmp0_subject = _ReactiveState___get_raw__impl__92ipya(this_0);
  var tmp;
  if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
    tmp = null;
  } else {
    if (tmp0_subject instanceof InternalReactiveThrownException()) {
      _ReactiveState___get_raw__impl__92ipya(this_0).sah_1;
      tmp = null;
    } else {
      if (tmp0_subject instanceof InternalReactiveWrapper()) {
        var tmp_0 = _ReactiveState___get_raw__impl__92ipya(this_0).rah_1;
        if (matching((tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE()))
          return Unit_instance;
        tmp = Unit_instance;
      } else {
        if (matching(_ReactiveState___get_raw__impl__92ipya(this_0)))
          return Unit_instance;
        tmp = Unit_instance;
      }
    }
  }
  var close = {_v: null};
  try {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
    // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
    var cancellable = new (CancellableContinuationImpl())(intercepted($completion), 1);
    cancellable.ra5();
    var cont = cancellable;
    close._v = _this__u8e3s4.tah(() => {
      // Inline function 'com.lightningkite.reactive.core.ReactiveState.onSuccess' call
      // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
      var this_0 = _this__u8e3s4.qah();
      var tmp0_subject = _ReactiveState___get_raw__impl__92ipya(this_0);
      var tmp;
      if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
        tmp = null;
      } else {
        if (tmp0_subject instanceof InternalReactiveThrownException()) {
          _ReactiveState___get_raw__impl__92ipya(this_0).sah_1;
          tmp = null;
        } else {
          if (tmp0_subject instanceof InternalReactiveWrapper()) {
            var tmp_0 = _ReactiveState___get_raw__impl__92ipya(this_0).rah_1;
            var it = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
            if (matching(it)) {
              // Inline function 'kotlin.coroutines.resume' call
              var this_1 = cont;
              // Inline function 'kotlin.Companion.success' call
              var tmp$ret$10 = _Result___init__impl__xyqfz8(Unit_instance);
              this_1.rc(tmp$ret$10);
            }
            tmp = Unit_instance;
          } else {
            var it_0 = _ReactiveState___get_raw__impl__92ipya(this_0);
            if (matching(it_0)) {
              // Inline function 'kotlin.coroutines.resume' call
              var this_2 = cont;
              // Inline function 'kotlin.Companion.success' call
              var tmp$ret$14 = _Result___init__impl__xyqfz8(Unit_instance);
              this_2.rc(tmp$ret$14);
            }
            tmp = Unit_instance;
          }
        }
      }
      return Unit_instance;
    });
    var tmp$ret$21 = cancellable.sa5();
    var tmp_1 = returnIfSuspended(tmp$ret$21, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
  }finally {
    var tmp0_safe_receiver = close._v;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver();
  }
  return Unit_instance;
}
function waitFor(_this__u8e3s4, matching, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_waitFor__s3rt0g.bind(VOID, _this__u8e3s4, matching), $completion);
}
function debounce(_this__u8e3s4, scope, duration) {
  return new (DebounceReactive())(_this__u8e3s4, scope, duration);
}
function ensureTotal(_this__u8e3s4, serializer) {
  var tmp0_safe_receiver = lastOrNull(_this__u8e3s4);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p4a_1;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.n4q();
  var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : singleOrNull(tmp2_safe_receiver);
  if ((tmp3_safe_receiver == null ? null : tmp3_safe_receiver.k20()) === '_id')
    return _this__u8e3s4;
  var tmp = new (DataClassPathSelf())(serializer);
  // Inline function 'kotlin.collections.find' call
  var tmp0 = ensureNotNull(get_serializableProperties(serializer));
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = tmp0.length;
    while (inductionVariable < last) {
      var element = tmp0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element.k20() === '_id') {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp_0 = tmp$ret$1;
  return plus_0(_this__u8e3s4, new (SortPart())(new (DataClassPathAccess())(tmp, (!(tmp_0 == null) ? isInterface(tmp_0, SerializableProperty()) : false) ? tmp_0 : THROW_CCE())));
}
var DebounceReactiveClass;
function DebounceReactive() {
  if (DebounceReactiveClass === VOID) {
    class $ {
      constructor(source, scope, duration) {
        this.xeo_1 = new (DebounceListenable())(source, scope, duration);
        this.yeo_1 = source;
        this.zeo_1 = scope;
        this.aep_1 = duration;
      }
      qah() {
        return this.yeo_1.qah();
      }
      toString() {
        return 'DebounceReactive(source=' + toString(this.yeo_1) + ', scope=' + toString(this.zeo_1) + ', duration=' + Duration__toString_impl_8d916b(this.aep_1) + ')';
      }
      hashCode() {
        var result = hashCode(this.yeo_1);
        result = imul(result, 31) + hashCode(this.zeo_1) | 0;
        result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.aep_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DebounceReactive()))
          return false;
        if (!equals(this.yeo_1, other.yeo_1))
          return false;
        if (!equals(this.zeo_1, other.zeo_1))
          return false;
        if (!(this.aep_1 === other.aep_1))
          return false;
        return true;
      }
      tah(listener) {
        return this.xeo_1.tah(listener);
      }
      iaj() {
        return this.xeo_1.iaj();
      }
    }
    initMetadataForClass($, 'DebounceReactive', VOID, VOID, [Reactive(), Listenable()]);
    DebounceReactiveClass = $;
  }
  return DebounceReactiveClass;
}
function *_generator_invoke__zhh2q8_1($this, $this$launch, $completion) {
  var tmp = delay($this.fep_1.dep_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if ($this.gep_1 === $this.fep_1.eep_1)
    $this.hep_1();
  return Unit_instance;
}
var DebounceListenable$addListener$lambda$slambdaClass;
function DebounceListenable$addListener$lambda$slambda() {
  if (DebounceListenable$addListener$lambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $num, $listener) {
        this.fep_1 = this$0;
        this.gep_1 = $num;
        this.hep_1 = $listener;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    DebounceListenable$addListener$lambda$slambdaClass = $;
  }
  return DebounceListenable$addListener$lambda$slambdaClass;
}
function DebounceListenable$addListener$lambda$slambda_0(this$0, $num, $listener) {
  var i = new (DebounceListenable$addListener$lambda$slambda())(this$0, $num, $listener);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var DebounceListenableClass;
function DebounceListenable() {
  if (DebounceListenableClass === VOID) {
    class $ {
      constructor(source, scope, duration) {
        this.bep_1 = source;
        this.cep_1 = scope;
        this.dep_1 = duration;
        this.eep_1 = 0;
      }
      tah(listener) {
        return this.bep_1.tah(() => {
          this.eep_1 = this.eep_1 + 1 | 0;
          var num = this.eep_1;
          launch(this.cep_1, VOID, VOID, DebounceListenable$addListener$lambda$slambda_0(this, num, listener));
          return Unit_instance;
        });
      }
      toString() {
        return 'DebounceListenable(source=' + toString(this.bep_1) + ', scope=' + toString(this.cep_1) + ', duration=' + Duration__toString_impl_8d916b(this.dep_1) + ')';
      }
      hashCode() {
        var result = hashCode(this.bep_1);
        result = imul(result, 31) + hashCode(this.cep_1) | 0;
        result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.dep_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DebounceListenable()))
          return false;
        if (!equals(this.bep_1, other.bep_1))
          return false;
        if (!equals(this.cep_1, other.cep_1))
          return false;
        if (!(this.dep_1 === other.dep_1))
          return false;
        return true;
      }
    }
    protoOf($).iaj = beginUse;
    initMetadataForClass($, 'DebounceListenable', VOID, VOID, [Listenable()]);
    DebounceListenableClass = $;
  }
  return DebounceListenableClass;
}
var ResourceUse$1Class;
function ResourceUse$1() {
  if (ResourceUse$1Class === VOID) {
    class $ {
      constructor($parentScope, $action) {
        this.iep_1 = $parentScope;
        this.jep_1 = $action;
      }
      iaj() {
        var job = Job(this.iep_1.ea2().cd(Key_instance));
        launch(CoroutineScope_0(this.iep_1.ea2().gp(job)), VOID, VOID, this.jep_1);
        return () => {
          job.ma3();
          return Unit_instance;
        };
      }
    }
    initMetadataForClass($);
    ResourceUse$1Class = $;
  }
  return ResourceUse$1Class;
}
var uses$1Class;
function uses$1() {
  if (uses$1Class === VOID) {
    class $ {
      constructor($this_uses, $resource) {
        this.mep_1 = $this_uses;
        this.nep_1 = $resource;
        this.kep_1 = 0;
        this.lep_1 = null;
      }
      qah() {
        return this.mep_1.qah();
      }
      tah(listener) {
        var _unary__edvuaz = this.kep_1;
        this.kep_1 = _unary__edvuaz + 1 | 0;
        if (_unary__edvuaz === 0) {
          this.lep_1 = this.nep_1.iaj();
        }
        var original = this.mep_1.tah(listener);
        return () => {
          original();
          var tmp;
          this.kep_1 = this.kep_1 - 1 | 0;
          if (this.kep_1 === 0) {
            var tmp0_safe_receiver = this.lep_1;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver();
            this.lep_1 = null;
            tmp = Unit_instance;
          }
          return Unit_instance;
        };
      }
    }
    protoOf($).iaj = beginUse;
    initMetadataForClass($, VOID, VOID, VOID, [Reactive()]);
    uses$1Class = $;
  }
  return uses$1Class;
}
function *_generator_invoke__zhh2q8_2($this, $this$launch, $completion) {
  var tmp = $this.oep_1.ea4($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var winningCandidate = tmp;
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = $this.pep_1.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (!equals($this.oep_1, element)) {
      element.ma3();
    }
  }
  $this.qep_1.na8(winningCandidate);
  return Unit_instance;
}
var race$slambda$slambdaClass;
function race$slambda$slambda() {
  if (race$slambda$slambdaClass === VOID) {
    class $ {
      constructor($racer) {
        this.rep_1 = $racer;
      }
      wah($this$async, $completion) {
        return this.rep_1($completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    race$slambda$slambdaClass = $;
  }
  return race$slambda$slambdaClass;
}
function race$slambda$slambda_0($racer) {
  var i = new (race$slambda$slambda())($racer);
  var l = ($this$async, $completion) => i.wah($this$async, $completion);
  l.$arity = 1;
  return l;
}
var race$slambda$slambdaClass_0;
function race$slambda$slambda_1() {
  if (race$slambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($racer, $list, $winningValue) {
        this.oep_1 = $racer;
        this.pep_1 = $list;
        this.qep_1 = $winningValue;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    race$slambda$slambdaClass_0 = $;
  }
  return race$slambda$slambdaClass_0;
}
function race$slambda$slambda_2($racer, $list, $winningValue) {
  var i = new (race$slambda$slambda_1())($racer, $list, $winningValue);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var race$slambdaClass;
function race$slambda() {
  if (race$slambdaClass === VOID) {
    class $ {
      constructor($racers) {
        this.sep_1 = $racers;
      }
      wah($this$coroutineScope, $completion) {
        // Inline function 'kotlin.collections.map' call
        var this_0 = this.sep_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.m1();
        while (_iterator__ex2g4s.n1()) {
          var item = _iterator__ex2g4s.o1();
          var tmp$ret$0 = async($this$coroutineScope, VOID, VOID, race$slambda$slambda_0(item));
          destination.v(tmp$ret$0);
        }
        var list = destination;
        var winningValue = CompletableDeferred();
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s_0 = list.m1();
        while (_iterator__ex2g4s_0.n1()) {
          var element = _iterator__ex2g4s_0.o1();
          launch($this$coroutineScope, VOID, VOID, race$slambda$slambda_2(element, list, winningValue));
        }
        return winningValue.ea4($completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    race$slambdaClass = $;
  }
  return race$slambdaClass;
}
function race$slambda_0($racers) {
  var i = new (race$slambda())($racers);
  var l = ($this$coroutineScope, $completion) => i.wah($this$coroutineScope, $completion);
  l.$arity = 1;
  return l;
}
//region block: exports
export {
  BaseResourceUse as BaseResourceUse29ny90pfhtji3,
  InterruptibleDelay as InterruptibleDelay2c0xh0wdvl7bj,
  ResourceUse as ResourceUse2vo6us5ch1uy1,
  debounce as debounce38x13ynq48dvf,
  ensureTotal as ensureTotaldlyk8c4gc8xl,
  uses as uses26aso754i5iou,
  waitFor as waitFor2a46u14jq5a6t,
};
//endregion

//# sourceMappingURL=utils.mjs.map
